const OTPService = (() => {
    /**
     * @param {string} country 
     * @param {string} countryText 
     * @param {string} lang 
     * @param {object} sessionData 
     * @param {object} userData 
     * @param {string} otp 
     * 
     * @return {object} - { success, data, message, error, urlType }
     */
    const validateOTP = (country, countryText, lang, sessionData, userData, otp) => {
        return new Promise((resolve, reject) => {
            try {
                const {
                    sessionId,
                    encryptedSessionId,
                    clientIp,
                    dataCenter
                } = sessionData;
    
                window.queryData.triggerRouterVerifyRecoveryFactor(otp, country, lang, sessionId) // verify pin api
                    .then((otpResponse) => {
                        if (otpResponse?.data?.verifyRecoveryFactor?.status === "SUCCESS") {
                            triggerRouterSignInCustomer(sessionId, country, lang, userData) //sign api
                                .then((signInData) => {
                                    if (signInData?.data?.signIn?.errorCode) {
                                        resolve({
                                            success: false,
                                            data: null,
                                            message: signInData?.data?.signIn?.message,
                                            error: signInData,
                                            urlType: null,
                                        });
                                    } else {
                                        window.queryData.triggerCustomerProfile(sessionId, signInData?.data?.signIn?.token?.accessToken, country, lang)
                                            .then((customerProfile) => {
                                                if (customerProfile?.data?.customerProfile?.errorCode) {
                                                    resolve({
                                                        success: false,
                                                        data: null,
                                                        message: customerProfile?.data?.customerProfile?.message,
                                                        error: customerProfile,
                                                        urlType: null,
                                                    });
                                                } else {
                                                    setDataInStorageR4(
                                                        customerProfile,
                                                        signInData,
                                                        lang,
                                                        userData,
                                                        country,
                                                        sessionId,
                                                        encryptedSessionId,
                                                        clientIp,
                                                        dataCenter
                                                    );
                                                    StorageService.setDataInStorage(
                                                        country,
                                                        lang,
                                                        sessionId,
                                                        encryptedSessionId,
                                                        userData,
                                                        countryText,
                                                        customerProfile
                                                    );
    
                                                    const accNumber = customerProfile?.data?.customerProfile?.customer?.accountNumber
                                                    sessionStorage.setItem('AccountNumber', accNumber);
                                                    const prepaidToken = signInData?.data?.signIn?.token?.prepaidToken || "";
                                                    sessionStorage.setItem('prepaidToken', prepaidToken);
    
                                                    const params = sendMoneyLink.getParam();
    
                                                    const urlType = params ? 'estimate-details' : 'start';
    
                                                    resolve({
                                                        success: true,
                                                        data: null,
                                                        message: null,
                                                        error: null,
                                                        urlType,
                                                    });
                                                }
                                            }).catch(error => {
                                                resolve({
                                                    success: false,
                                                    data: null,
                                                    message: null,
                                                    error,
                                                    urlType: null,
                                                });
                                            });
                                    }
    
                                }).catch(error => {
                                    resolve({
                                        success: false,
                                        data: null,
                                        message: null,
                                        error,
                                        urlType: null,
                                    });
                                })
                        } else {
                            resolve({
                                success: false,
                                data: null,
                                message: null,
                                error: null,
                                urlType: null,
                            });
                        }
                    }).catch(error => {
                        resolve({
                            success: false,
                            data: null,
                            message: null,
                            error,
                            urlType: null,
                        });
                    });
            } catch(error) {
                resolve({
                    success: false,
                    data: null,
                    message: null,
                    error,
                    urlType: null,
                });
            }
        });
    };

    /**
     * @param {string} country 
     * @param {string} lang 
     * @param {object} sessionData 
     * @param {object} userData 
     * 
     * @return {object} - { success, data, message, error, urlType }
     */
    const resendTriggerOTP = (country, lang, sessionData, userData) => {
        return new Promise((resolve, reject) => {
            try {
                const { sessionId } = sessionData;

                window.queryData.triggerResendRecoveryFactor(country, lang, sessionId, userData.emailId) //call resend api
                    .then(() => {
                        resolve({
                            success: true,
                            data: null,
                            message: null,
                            error: null,
                            urlType: null,
                        });
                    }).catch(error => {
                        resolve({
                            success: false,
                            data: null,
                            message: null,
                            error,
                            urlType: null,
                        });
                    })
            } catch (error) {
                console.error('error from trigger register : ', error)
                resolve({
                    success: false,
                    data: null,
                    message: null,
                    error,
                    urlType: null,
                });
            }
        });
    };

    return {
        validateOTP,
        resendTriggerOTP,
    };
})();

window.OTPService = OTPService